var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ElementVotes',{attrs:{"votes":_vm.fulfillmentVotes,"current-user-vote-type":_vm.userVoteType},on:{"voteClick":_vm.voteClick}})}
var staticRenderFns = []

export { render, staticRenderFns }